import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { GearIcon, LogoutIcon } from "@components/icons";
import { useLogout } from "@hooks/useLogout";
import { CustomerDetailsMenuButton } from "./CustomerDetailsMenuButton";

interface ICustomerDetailsMenuProps {
  style?: React.CSSProperties;
}

export const CustomerDetailsMenu: React.FC<ICustomerDetailsMenuProps> = (
  props,
) => {
  const { style } = props;

  const { t } = useTranslation();
  const navigate = useNavigate();

  const { logout, isPending } = useLogout();

  return (
    <div
      style={style}
      className="flex flex-col rounded-xl border border-grey-light bg-white p-2"
    >
      <CustomerDetailsMenuButton
        icon={GearIcon}
        onClick={() => navigate("/settings")}
      >
        {t("pages.settings.title")}
      </CustomerDetailsMenuButton>
      <CustomerDetailsMenuButton
        icon={LogoutIcon}
        onClick={logout}
        isLoading={isPending}
      >
        {t("pages.logout.title")}
      </CustomerDetailsMenuButton>
    </div>
  );
};
